import { indexmethadologyUploader } from "Common/utils/imageUploader";
import { showNotification } from "Common/utils/Notification";
import { useEffect, useState } from "react";
import Drawer from "Common/Components/Drawer";
import { TailSpin } from "react-loader-spinner";
import { X } from "lucide-react";
import { getImageUrl } from "Common/utils/ImageDomain";
import _ from "lodash";

export default function MethodologyFileUploader({
  buttonText,
  keyValue,
  language,
  versionCopy,
  formData,
  handleUpdate,
  defaultToggle,
  id,
}: any) {
  console.log(formData, "formData");
  console.log(keyValue, "keyValue");
  console.log(language, "language");
  console.log(versionCopy, "versionCopy");

  const [isDocument, setIsDocument] = useState<any>(
    formData[keyValue] ? false : true
  );

  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [docView, setDocView] = useState(null);
  const [showMode, setShowMode] = useState(false);

  const [documentView, setDocumentView] = useState(null);

  const handleView = () => {
    setLoading(true);
    let url = versionCopy[keyValue];
    let parsedUrl = new URL(url);

    let newurl = parsedUrl.pathname.substring(1); 
    window.open(
      `${process.env.REACT_APP_IMAGE_URL}/${newurl}`,
      "_blank"
    );
    
  };

  useEffect(() => {
    setSelectedFile(null);
    setIsDocument(!formData[keyValue]);
  }, [keyValue, formData[keyValue]]);

  //methodology
  const handleAcceptedFiles = async (file: any) => {
    if (file?.type?.split("/")[1] === "pdf") {
      setIsLoading(true);
      const res = await indexmethadologyUploader(file, id);
      setIsLoading(false);
      if (res.status === "Success") {
        showNotification("Uploaded successfully", "success");
        handleUpdate(res.data.fileData, keyValue);
        setSelectedFile(res.data.fileData);
      } else {
        setIsLoading(false);
      }
    } else {
      showNotification("File type should be pdf", "error");
    }
  };

  return (
    <>
      {!_.isEmpty(versionCopy) ? (
        <div className="col-span-1">
          <label className="block mb-1 font-medium">
            {`Old - ${buttonText}`}
          </label>
          <button
            type="button"
            disabled={!versionCopy?.[keyValue]}
            className="flex items-center px-4 py-2 space-x-2 border border-gray-300 rounded-md hover:bg-gray-100"
            onClick={handleView}
          >
            ⬇️ <span>{buttonText}</span>
          </button>
        </div>
      ) : null}
      {formData[keyValue] || selectedFile?.file_url ? (
        <div className="col-span-1">
          <label className="block mb-1 font-medium">
            {`${language} Methodology`}
          </label>

          <div className="flex gap-2 ">
            <input
              type="file"
              hidden
              id={`uploadimage-${language}`}
              accept="application/pdf"
              className="hidden profile-img-file-input"
              onChange={(e: any) => handleAcceptedFiles(e.target.files[0])}
            />
            <label
              htmlFor={`uploadimage-${language}`}
              className="flex items-center px-4 py-2 space-x-2 border border-gray-300 rounded-md hover:bg-gray-100"
            >
              📂 Change {language} Methodology
            </label>

            <div
              onClick={() => {
                let document = selectedFile?.file_url || formData[keyValue];
                setDocumentView({
                  document,

                  file_name: selectedFile?.file_name
                    ? selectedFile?.file_name
                    : null,
                });
                setShowMode(true);
                setDocView(language);
              }}
              className="flex items-center px-4 py-2 space-x-2 border border-gray-300 rounded-md hover:bg-gray-100"
            >
              View
            </div>
          </div>
          <div className="w-4/5 mt-2">
            {selectedFile?.file_name || `...${formData[keyValue]?.slice(-50)}`}
          </div>
        </div>
      ) : (
        <>
          {/* <div className="col-span-1">
                        <label className="block mb-1 font-medium">
  {`${language.charAt(0).toUpperCase() + language.slice(1)} Methodology`}
</label>

                        <input
  type="file"
  hidden
  id={`uploadimage-${language}`}
                            accept="application/pdf"
                            className="hidden profile-img-file-input"
                            onChange={(e: any) =>
                                handleAcceptedFiles(e.target.files[0])
                            }
                        />
                        <label
                            htmlFor={`uploadimage-${language}`}
                            className="flex items-center px-4 py-2 space-x-2 border border-gray-300 rounded-md hover:bg-gray-100"
                        >
                            {" ⬆️ " + buttonText + " Methodology File"}
                        </label>
                    </div> */}
          <div className="col-span-1">
            <label className="block mb-1 font-medium">
              {`${
                language.charAt(0).toUpperCase() + language.slice(1)
              } Methodology`}
            </label>
            <input
              type="file"
              hidden
              id={`uploadimage-${language}`}
              accept="application/pdf"
              className="hidden profile-img-file-input"
              onChange={(e: any) => handleAcceptedFiles(e.target.files[0])}
            />
            <label
              htmlFor={`uploadimage-${language}`}
              className="flex items-center px-4 py-2 space-x-2 border border-gray-300 rounded-md hover:bg-gray-100"
            >
              {" ⬆️ " + buttonText + " Methodology File"}
            </label>
          </div>
        </>
      )}

      <Drawer
        show={showMode}
        onHide={() => setShowMode(false)}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">
            {docView?.file_name ? docView?.file_name : "Document View"}
          </Drawer.Title>
          <button
            type="button"
            onClick={(e) => {
              e.preventDefault();
              setShowMode(false);
            }}
            className="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
          >
            <X />
          </button>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          {getImageUrl(
            documentView?.document ? documentView?.document : null
          ).endsWith(".pdf") ? (
            <iframe
              src={`${getImageUrl(
                documentView?.document ? documentView?.document : null
              )}#toolbar=0`}
              className="w-[80vh] h-[80vh] rounded-md"
            />
          ) : (
            <iframe
              src={
                documentView === undefined
                  ? getImageUrl(
                      documentView?.document ? documentView?.document : null
                    )
                  : documentView?.document
                  ? documentView?.document
                  : null
              }
              className="w-[80vh] h-[80vh] rounded-md"
            />
          )}
        </Drawer.Body>
      </Drawer>
    </>
  );
}
